import { render } from "./AuthoringSkeletonLoader.vue?vue&type=template&id=4516c103&scoped=true"
import script from "./AuthoringSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./AuthoringSkeletonLoader.vue?vue&type=script&lang=js"

import "./AuthoringSkeletonLoader.vue?vue&type=style&index=0&id=4516c103&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4516c103"]])

export default __exports__